import { Component, inject, input, OnInit } from '@angular/core';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RealEstateTemplateInfoComponent } from '../real-estate-template-info/real-estate-template-info.component';
import { DataUtils, ISelectItem } from '../../../utils/data.util';
import { Category, ImportService } from '../../../api';
import { AlcoholTemplateInfoComponent } from '../alcohol-template-info/alcohol-template-info.component';
import { CarTemplateInfoComponent } from '../car-template-info/car-template-info.component';
import { JewelsTemplateInfoComponent } from '../jewels-template-info/jewels-template-info.component';
import { GemstoneTemplateInfoComponent } from '../gemstone-template-info/gemstone-template-info.component';
import { InstrumentTemplateInfoComponent } from '../instrument-template-info/instrument-template-info.component';
import { CoinsTemplateInfoComponent } from '../coins-template-info/coins-template-info.component';
import { BanknoteTemplateInfoComponent } from '../banknote-template-info/banknote-template-info.component';
import { ArtTemplateInfoComponent } from '../art-template-info/art-template-info.component';
import { LoanTemplateInfoComponent } from '../loan-template-info/loan-template-info.component';
import { SharesTemplateInfoComponent } from '../shares-template-info/shares-template-info.component';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-download-template',
  imports: [
    Select,
    FormsModule,
    TranslatePipe,
    RealEstateTemplateInfoComponent,
    AlcoholTemplateInfoComponent,
    CarTemplateInfoComponent,
    JewelsTemplateInfoComponent,
    GemstoneTemplateInfoComponent,
    InstrumentTemplateInfoComponent,
    CoinsTemplateInfoComponent,
    BanknoteTemplateInfoComponent,
    ArtTemplateInfoComponent,
    LoanTemplateInfoComponent,
    SharesTemplateInfoComponent,
  ],
  templateUrl: './download-template.component.html',
  styleUrl: './download-template.component.scss',
})
export class DownloadTemplateComponent implements OnInit {
  selectedCategory: any;
  categories: Array<ISelectItem<Category>> = [];
  translationPrefix = input('', { transform: appendPrefix });
  translate = inject(TranslateService);
  dataUtils = inject(DataUtils);
  importService = inject(ImportService);

  ngOnInit(): void {
    this.categories = this.dataUtils.mapCategories();
  }

  public invokeDownload() {
    const a = document.createElement('a');
    const selectedCategoryLabel = this.selectedCategory.id.toLowerCase();
    this.importService
      .getImportTemplate(self.crypto.randomUUID(), this.selectedCategory.id)
      .subscribe(data => {
        saveAs(data, this.selectedCategory.id + '.csv');
      });
  }
}
function appendPrefix(value: string | undefined): string {
  return value + 'downloadTemplate.';
}
